var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashCanOutlineIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    id: "svg6",
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5,0 V 1 H 0 v 2 h 1 v 13 a 2,2 0 0 0 2,2 h 10 a 2,2 0 0 0 2,-2 V 3 h 1 V 1 H 11 V 0 H 5 M 3,3 H 13 V 16 H 3 V 3 m 2,2 v 9 H 7 V 5 H 5 m 4,0 v 9 h 2 V 5 Z",
    id: "path4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashCanOutlineIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash-can-outline-icon.ec879ff8f8642c0a7d879d1228009013.svg";